<div class="container fx-layout-row-wrap">

    <div *ngFor="let voice of voices; index as i" class="fx-flex-100" style="height: 10%; margin-top: 1rem;">
        <app-custom-card2 #childs [id]="i" [currentSelected]="currentSelected" [text]="voices[i]" [icon]="icons[i]" (click)="this.selected($event)">
        </app-custom-card2>
    </div>

</div>